import React from 'react';
import AuditRemarksModal from "./AuditRemarksModal";
import {regulation} from "../extendFieldsConfig";

export default class AuditRemarks extends AuditRemarksModal {

    getFormData() {
        return this.state.formData;
    }

    setFormData(processType, activityExt = {}, activityTypeData = []) {
        this.setState({
            formData: JSON.parse(JSON.stringify(activityExt)),
            finalData: JSON.parse(JSON.stringify(activityExt)),
        }, () => this.getAuditRemarksData(processType, activityTypeData))
    }

    // 获取审核备注数据
    getAuditRemarksData = (processType, activityTypeData) => {
        const {isAuditing, formData} = this.props;
        let url = "/cm-sites-media-consumer/system/activityField/getByActivityTypeId";
        let {id: typeId} = activityTypeData.find(({type: activityType}) => activityType === processType) || {};
        let body = {typeId};
        // 解决流程中添加字段流程卡死问题
        if(isAuditing) {
            url = "/cm-sites-media-consumer/system/activityField/getByPositionId";
            body = {id: formData.id, typeId}
        }
        this.request({
            url: url,
            body: body,
            callBack: (res) => {
                let auditRemarksData = [];
                if (res && res.length && (res.filter(item => item.status).length)) {
                    auditRemarksData = res.filter(item => item.status).map(item => ({
                        col: item.col,
                        componentType: regulation[item.fieldType],
                        value: this.getValue(item.dbFieldName),
                        labelName: item.fieldName,
                        labelCode: item.dbFieldName,
                        fieldProps: {
                            placeholder: this.getPlaceHolderText(item, item.fieldName),
                            message: this.getPlaceHolderText(item, item.fieldName),
                            size: "default", // 标签大小
                            options: item.fieldFillRules?.[0]?.keyValueMaps && Object.keys(item.fieldFillRules[0].keyValueMaps).length && Object.keys(item.fieldFillRules[0].keyValueMaps).map(i => ({
                                key: i,
                                label: item.fieldFillRules[0].keyValueMaps[i]
                            })),
                            fieldFillRules: item.fieldFillRules,
                            display: item.status ? "block" : "none",
                            disabled: this.formIsDisabled(),
                            fieldType: item.fieldType,
                            fieldTip: item.fieldTip,
                            uploadCount: item.fieldFillRules && item.fieldFillRules?.[0]?.uploadCount,
                            show: item.show,
                            canEdit: item.canEdit,
                            confirmContent: item.fieldFillRules && item.fieldFillRules?.[0]?.confirmContent,
                        },
                        options: {
                            rules: this.setRules(item.fieldFillRules)
                        },
                        maxLength: 999,
                        required: item.required === -1 ? false : !!item.required,
                        id: "information_" + item.dbFieldName,
                    }));
                }
                this.setState({
                    auditRemarksData
                });
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    };

    render() {
        return (
            <>
                {this.renderDynamicForm()}
            </>
        )
    }

}